import {useEffect, useState} from "react";
import {
    Box,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    Typography,
    IconButton
} from "@mui/material";
import {

    Telegram,
    WhatsApp,
    Instagram,
    Mail,
      LinkedIn
} from '@mui/icons-material'
import {Menu} from '@mui/icons-material'
import {Link} from 'react-router-dom'




import {useNavigate} from 'react-router-dom'
import {getSplash} from "../services/services";


const Navbar = (props) => {

    const [data, setData] = useState(false)

    const getData = async () => {
        const response = await getSplash()
        if (response && response.data.code == 1) {
            setData(response.data)
        } else {
            alert('مشکل در ارتباط با سرور')
        }
    }


    useEffect(() => {

        getData()
    }, []);

    // using this to make the active page noticeable in navbar
    const [activePage, setActivePage] = useState(0)
    const handleActivePage = (page) => {
        setActivePage(page)
    }


    const nav = useNavigate()

    const drawerWidth = 240;
    const {window} = props;
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setTimeout(() => setMobileOpen((prevState) => !prevState), 300)

    };





    const drawer = (
        <Box sx={{textAlign: 'center'}}>
            <Typography onClick={() => {
                nav('/');
                handleActivePage(0)
            }} className='kook' variant="h6" sx={{my: 2}}>
             بازرگانی قاسمی
            </Typography>

            <Divider sx={{my: 1}}/>


            <List sx={{
                '& .Mui-selected': {
                    border: '0.15rem dashed #00A651',
                    borderRadius: '0.5rem',
                    backgroundColor: '#ffffff',
                    mx: 1,
                    justifyContent: 'start',
                    pr: '2rem'
                }
            }}>

                <ListItem onClick={handleDrawerToggle} disablePadding>
                    <ListItemButton selected={activePage === 0} onClick={() => {
                        nav('/');
                        handleActivePage(0)
                    }}
                                    sx={{textAlign: 'center', height: '3rem'}}>
                        <Typography className='kook' variant="h6" component='a' sx={{my: 2 , color:'inherit'}}>
                            صفحه اصلی
                        </Typography>
                    </ListItemButton>
                </ListItem>



                <ListItem onClick={handleDrawerToggle} disablePadding>
                    <ListItemButton selected={activePage === 2} onClick={() => {
                        nav('/news/');
                        handleActivePage(2)
                    }} sx={{textAlign: 'center', height: '3rem'}}>
                        <Typography className='kook' variant="h6" component='a' sx={{my: 2 , color:'inherit'}}>
                            اخبار و محصولات
                        </Typography>
                    </ListItemButton>
                </ListItem>


                <ListItem onClick={handleDrawerToggle} disablePadding>
                    <ListItemButton selected={activePage === 4} onClick={() => {
                        nav('/contact/');
                        handleActivePage(4)
                    }} sx={{textAlign: 'center', height: '3rem'}}>
                        <Typography className='kook' variant="h6" component='a' sx={{my: 2 , color:'inherit'}}>
                            تماس با ما
                        </Typography>
                    </ListItemButton>
                </ListItem>

                <ListItem onClick={handleDrawerToggle} disablePadding>
                    <ListItemButton selected={activePage === 3} onClick={() => {
                        nav('/faq/');
                        handleActivePage(3)
                    }} sx={{textAlign: 'center', height: '3rem'}}>
                        <Typography className='kook' variant="h6" component='a' sx={{my: 2 , color:'inherit'}}>
                           سوالات متداول
                        </Typography>
                    </ListItemButton>
                </ListItem>
                <a  href={data && data.options.whatsapp} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS  '>
                    <WhatsApp className='clrthree scoialhover my-4   '/>
                </a>
                <a href={data && data.options.telegram} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS'>
                    <Telegram className='clrthree scoialhover my-4'/>
                </a>


                <a href={data && data.options.instagram} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS'>
                    <Instagram className='clrthree scoialhover my-4'/>
                </a>





            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;


    return (
        <>
            <header>


                <nav className="navbar stcikynavmobile  is-justify-content-center pb-0 kook"
                     role="navigation"
                     aria-label="main navigation" style={{width: '100%'}}
                >


                    {/*Responsive Drawer*/}
                    <nav>
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            anchor='right'
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{
                                display: {xs: 'block', sm: 'block', md: 'block'},
                                '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth , backgroundColor:'rgba(255, 255, 255, 0.93)' , backdropFilter:'blur(3px)' , borderLeft:'0.3rem solid #219ebc' },

                            }}
                        >

                            {drawer}
                        </Drawer>
                    </nav>

                    {/*Responsive Drawer*/}

                    {/*responsive*/}
                    <div className='is-flex is-justify-content-space-between is-align-items-center is-hidden-desktop'>



                        <a className=' mx-3 '   onClick={() => {
                            nav('/');
                            handleActivePage(0)
                        }}

                          >
                            <img className='mr-auto' src="/icons/logo.png" width={50} height={50} style={{maxHeight: '50px'}}/>



                        </a>




                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ml: 1, display: {lg: 'none'}}}
                        >
                            <Menu className='is-size-3'/>
                        </IconButton>



                    </div>


                    <div className='columns is-multiline m-0 wdith100 is-hidden-touch    '>

                        <div className='column is-2 is-flex is-flex-direction-row flex-JCS-ACS '>





                       
                        </div>


                        <div className='column is-8 is-flex is-flex-direction-row flex-JCS-ACS'>
                            <Link to={'/'} className={`navbar-item clronetext  underline `}>


                                صفحه اصلی
                            </Link>



                            <Link to={'/news/'}  className={`navbar-item clronetext  underline`} >
                                اخبار و محصولات
                            </Link>

                            <Link to={'/'} className={`navbar-item clronetext is-hidden-mobile underline px-6 `}
                                  style={{alignItems: 'center'}}>
                                <img src="/icons/logo.png" width={80} height={150} style={{maxHeight: '150px'}}/>




                            </Link>


                            <Link to={'/faq/'}  className={`navbar-item clronetext  underline `}>
                                سوالات متداول
                            </Link>

                            <Link to={'/contact/'} className={`navbar-item clronetext  underline `}>
                                ارتباط با ما
                            </Link>




                        </div>


                        <div className='column is-2 is-flex is-flex-direction-row flex-JCS-ACS'>
                            
                        <a href={data && data.options.whatsapp} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS  '>
                                <WhatsApp className='clrthree scoialhover   '/>
                            </a>
                            <a href={data && data.options.telegram} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS'>
                                <Telegram className='clrthree scoialhover'/>
                            </a>
                                

                            <a href={data && data.options.instagram} target='_blank' rel='noopener noreferrer' className='mx-1 p-1 is-flex flex-JCS-ACS'>
                                <Instagram className='clrthree scoialhover'/>
                            </a>
                        </div>


                    </div>


                </nav>

            </header>

        </>
    )
}
export default Navbar;